<template>
	<fragment v-if="!slAttribute && !isMultiple">
		<label :id="attributeName + '_label'"
			   :for="attributeName">
            <span v-if="enableCopyAttributeName"
				  class="fa fa-files-o label-copy-icon"
				  v-bind-copy-to-clipboard="attributeName"/>
			<i v-if="isSequence && isCreatePage" class="fa fa-retweet"/>
			<i v-if="richText && !lockedEdit"
			   class="fa fa-pencil"
			   aria-hidden="true"
			   @click="richTextHandler"/>
			<i v-if="isExpression && !lockedEdit"
			   class="fa fa-calculator"
			   aria-hidden="true"
			   v-bind-tooltip:[isExpression]="expression"
			   @click="recalculateAttribute"/>
			<span v-if="requiredLabelIcon" :class="requiredLabelIcon"/>
			<span v-if="requiredPrimaryIcon" :class="requiredPrimaryIcon"/>
			<i v-if="lockedEdit" class="fa fa-lock"/>

			<label-tooltip :label="$t(localizedTitle)"/>
			<button v-if="isPrev && !lockedEdit" class="button_plus fa fa-plus dictionary-expander" tabindex="-1"/>

		</label>
	</fragment>
	<fragment v-else>
		<label class="caption-label" :id="attributeName + '_label__' + index"
			   :for="attributeName + '__' + index" :data-language="lang">
      	<span v-if="enableCopyAttributeName" class="fa fa-files-o label-copy-icon"
			  v-bind-copy-to-clipboard="attributeName  + '__' + lang"/>
			<i v-if="richText && !lockedEdit"
			   class="fa fa-pencil"
			   style="margin-right: 5px; color: #333333;"
			   aria-hidden="true"
			   @click="richTextHandler"/>
			<span v-if="requiredLabelIcon" :class="requiredLabelIcon"/>
			<span v-if="requiredPrimaryIcon" :class="requiredPrimaryIcon"/>
			<i v-if="lockedEdit" class="fa fa-lock"/>

			<label-tooltip :label="$t(localizedTitle) + language"/>
			<button v-if="slAttribute && isPrev && !lockedEdit" class="button_plus fa fa-plus dictionary-expander"
					tabindex="-1"/>

		</label>
	</fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { attributeLabel } from '@/mixins/attributeLabel'
import LabelTooltip from '@/components/item-edit/partials/LabelTooltip'

export default {
	components: {
		Fragment,
		LabelTooltip
	},
	name: 'AttributeLabel',
	props: {
		attributeName: {
			type: String,
			required: true
		},
		localizedTitle: {
			type: String,
			required: true
		},
		isMultiple: {
			type: Boolean,
		},
		isPrimary: {
			type: Boolean,
			required: false,
			default: false
		},
		isSequence: {
			type: Boolean,
			required: false,
			default: false
		},
		expression: {
			type: String,
			required: false,
			default: null
		},
		maxCount: {
			type: [String, Number]
		},
		slAttribute: {
			type: Boolean,
			required: false,
			default: false
		},
		enableCopyAttributeName: {
			type: Boolean
		},
		lang: {
			type: String,
			default: ''
		},
		index: {
			type: Number,
			default: 0
		},
		isPrev: {
			type: Boolean,
			default: false
		},
		lockedEdit: {
			type: Boolean,
			default: false
		},
		richText: {
			type: Boolean,
			default: false
		}
	},
	mixins: [
		attributeLabel
	],
	data () {
		return {
			language: this.lang ? ' (' + this.lang + ')' : '',
			isExpression: !!this.expression
		}
	},
	computed: {
		isCreatePage () {
			return this.$store.state.configurations.isCreatePage
		}
	},
	directives: {
		bindCopyToClipboard: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'CopyToClipboard(\'{' + binding.value + '}\')')
			}
		},
		bindTooltip: function (el, binding) {
			if (binding.arg) {
				$(el).tooltip({
					title: binding.value,
					placement: 'auto',
					selector: '',
					container: 'body'
				})
			}
		}
	},
	methods: {
		recalculateAttribute: function (event) {
			event.preventDefault()
			this.$emit('recalculate')
		},
		richTextHandler (event) {
			event.preventDefault()
			this.$emit('rich-text-handler')
		}
	}
}
</script>

<style scoped>
i {
	cursor: pointer;
}
</style>
